export const scrollbarSX = {
  "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
    backgroundColor: "#0000",
    width: "5px",
  },
  "&::-webkit-scrollbar-track-piece": {
    backgroundColor: "#0000",
    border: "1px solid #dfe0f2",
    borderRight: "0px",
    borderRadius: 8,
  },
  "&::-webkit-scrollbar-track-piece:end ": {
    marginBottom: "25px",
  },
  "&::-webkit-scrollbar-track-piece:start ": {
    marginTop: "25px",
  },
  "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
    borderRadius: 8,
    backgroundColor: "#1a0549",
    minHeight: 24,
    border: "0px solid white",
    height: "10px",
  },
  "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
    backgroundColor: "#1a0549",
  },
  "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
    backgroundColor: "#1a0549",
  },
  "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#1a0549",
  },
}
